import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import ContactButtons from "@/components/ContactButtons";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#08080a] border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo imgClass="h-12 w-12" textClass="text-3xl" />
          <p className="text-zinc-400 font-light mt-5 max-w-sm leading-relaxed">
            Chauffeured luxury for those who measure travel in moments, not miles. Available 24/7.
          </p>
          <ContactButtons className="mt-6" align="left" />
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs tracking-label uppercase text-zinc-500 mb-5">Navigate</h4>
          <ul className="space-y-3 text-zinc-300 font-light">
            <li><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="hover:text-[#D4AF37] transition-colors">Home</Link></li>
            <li><Link to="/fleet" className="hover:text-[#D4AF37] transition-colors">Our Fleet</Link></li>
            <li><Link to="/login" className="hover:text-[#D4AF37] transition-colors">Sign In</Link></li>
            <li><Link to="/register" className="hover:text-[#D4AF37] transition-colors">Create Account</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-zinc-500 text-sm font-light">© {new Date().getFullYear()} Aspen Executive Limo. All rights reserved.</p>
        <p className="text-zinc-600 text-sm font-mono">Crafted for the discerning traveler.</p>
      </div>
    </footer>
  );
}
